export const formatPrice = (value) => {
  if (typeof value !== "number") return value;
  return value.toLocaleString("tr-TR", { minimumFractionDigits: 2 });
};

export const formatCurrency = (value) => {
  if (typeof value !== "number") return value;
  return value.toLocaleString("tr-TR", {
    style: "currency",
    currency: "TRY",
    minimumFractionDigits: 2,
  });
};

export function formatPotential(value) {
  if (typeof value !== "number") return value;
  return `${value >= 0 ? "+" : ""}${value.toFixed(2)}%`;
}
